import { createContext } from 'react'

export const SelectedReleaseNoteTypesContext = createContext<string[]|undefined>(undefined)
